import palette from './palette';

const styles = {
  text: {
    fontSize: '0.875rem',
    color: palette.typography.black.solid,
    letterSpacing: '0.0025em',
    paddingBottom: '1.688rem',
    whiteSpace: 'pre-wrap',
  },
  yellowButton: {
    backgroundColor: palette.yellow,
    border: palette.btn.blueBorder,
    color: palette.typography.black.solid,
    '&:hover': {
      backgroundColor: palette.yellow,
    },
  },
  blueButton: {
    backgroundColor: palette.btn.blueFill,
    border: palette.btn.blueBorder,
    '&:hover': {
      backgroundColor: palette.btn.blueFill,
    },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  noPadding: {
    padding: 0,
  },
  loadingContainer: {
    minHeight: '150px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  bold: {
    fontWeight: 600,
  },
};

export default styles;
